import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useFromStore } from '../../utils/createStore';
import SelectLanguage from './SelectLanguage';
import getSyntax from '../utils/getSyntax';
import updateBlockLanguage from '../utils/updateBlockLanguage';
import IconButton from '../../../components/IconButton';
import { AllNotesIcon, MoreIcon } from '../../../components/Icons';
import textSerializer from './../../../utils/textSerializer';
import { ENABLE_CODE_WRAPPING, DISABLE_CODE_WRAPPING, FULL_WIDTH_EXPAND, FULL_WIDTH_SHRINK, DELETE } from '../../../types/BlockActionTypes';
import copy from 'copy-to-clipboard';
var CODE_WRAPPING_ENABLED_PRE_STYLE = {
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word'
};
var CODE_WRAPPING_DISABLED_PRE_STYLE = {};

function CodeContainer(props) {
  var isMobile = props.isMobile,
      attributes = props.attributes,
      children = props.children,
      editor = props.editor,
      node = props.node,
      store = props.store;
  var language = getSyntax(node.nodes.first());
  var preStyle = useFromStore(store, 'codeWrappingEnabled') ? CODE_WRAPPING_ENABLED_PRE_STYLE : CODE_WRAPPING_DISABLED_PRE_STYLE;
  var onChangeLanguage = useCallback(function (language) {
    updateBlockLanguage({
      editor: editor,
      block: node,
      language: language
    });
  }, [node, editor]);
  var onClickCopy = useCallback(function () {
    var code = editor.value.document.getDescendant(node.key);
    copy(textSerializer()(code));
    editor.command('openToast', {
      title: 'Copied!',
      detail: "The snippet has been copied to your clipboard."
    });
  }, [editor, node]);
  var onClickOptions = useCallback(function (event) {
    editor.command('openBlockAction', node, event.currentTarget, 'bottom-start', [ENABLE_CODE_WRAPPING, DISABLE_CODE_WRAPPING, FULL_WIDTH_EXPAND, FULL_WIDTH_SHRINK, DELETE]);
  }, [node, editor]);
  return React.createElement("div", Object.assign({
    className: classNames('note-editor-code-container', 'position-relative', 'margin-top-small')
  }, attributes), React.createElement("div", {
    className: "flexbox flex-row flexbox-align-center background-shade-45 padding-small radius-top-normal"
  }, React.createElement(SelectLanguage, {
    onChange: onChangeLanguage,
    value: language,
    editor: editor,
    readOnly: editor.readOnly || isMobile
  }), React.createElement("span", {
    className: "margin-left-auto no-print",
    contentEditable: false
  }, React.createElement(IconButton, {
    colorScheme: "grayOnGray",
    tooltipPosition: "top",
    tooltip: "Copy",
    onClick: onClickCopy
  }, React.createElement(AllNotesIcon, {
    size: 16
  })), !editor.readOnly && !isMobile && React.createElement(IconButton, {
    colorScheme: "grayOnGray",
    tooltipPosition: "top",
    tooltip: "Options",
    onClick: onClickOptions
  }, React.createElement(MoreIcon, {
    size: 16,
    className: "rotate-clockwise"
  })))), React.createElement("pre", {
    spellCheck: false,
    className: classNames('background-shade-50', 'radius-bottom-normal', 'padding-vertical-normal', 'font-size-large'),
    style: preStyle
  }, children));
}

export default React.memo(CodeContainer);